import moment from 'moment';
import { DateTime } from 'luxon';

import PFDate from './PFDate.helper';
import { DATE_FORMATS } from './Helpers';
export const getUSerTimeZone = () => {
  return moment.tz.guess();
};

export const getConvertedDate = inputDate => {
  if (!inputDate) return null;
  const resultDate = getUSerTimeZone()
    ? moment(inputDate).tz(getUSerTimeZone())
    : moment(inputDate);
  return resultDate.format('MM-DD-YYYY hh:mm A');
};

export const UTCConvertor = (date, withTime = true) => {
  if (!date) return null;
  return withTime
    ? moment.utc(date).local().format('MM-DD-YYYY hh:mm:ss A')
    : moment.utc(date).local().format('MM-DD-YYYY');
};

export const formatToUTCStartOfDay = date => {
  if (!date || !moment(date).isValid()) return null;
  return moment.utc(date).startOf('day').toISOString();
};
export function convertDateToClientZuluTime(
  dateInIST,
  clientTz = localStorage.getItem('client_timezone')
) {
  const ist = DateTime.fromJSDate(dateInIST);
  const reinterpreted = DateTime.fromObject(
    {
      year: ist.year,
      month: ist.month,
      day: ist.day,
      hour: ist.hour,
      minute: ist.minute,
      second: ist.second,
      millisecond: ist.millisecond,
    },
    { zone: clientTz }
  );

  return reinterpreted.toUTC().toISO();
}

export function convertDateToClient(
  dateInIST,
  isFormatted = false,
  considerTimeSection = true
) {
  const clientTz = localStorage.getItem('client_timezone');
  const ist = DateTime.fromJSDate(dateInIST);
  const reinterpreted = DateTime.fromObject(
    {
      year: ist.year,
      month: ist.month,
      day: ist.day,
      ...(considerTimeSection
        ? {
            hour: ist.hour,
            minute: ist.minute,
            second: ist.second,
            millisecond: ist.millisecond,
          }
        : {
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          }),
    },
    { zone: clientTz }
  );
  if (isFormatted) {
    return reinterpreted.toFormat('yyyy-MM-dd hh:mm a');
  }
  return reinterpreted;
}

export const formatPFDateTime = (date, format = DATE_FORMATS.DEFAULT) => {
  return date ? PFDate(date).format(format) : '';
};
export const formatTo12Hour = time => {
  if (!time) return '';

  const [hours = '0', minutes = '0'] = time.split(':');

  const date = new Date();
  date.setHours(Number(hours));
  date.setMinutes(Number(minutes));

  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};
export const getWeekdayName = dateInput => {
  const dateObj =
    typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  return dateObj.toLocaleDateString('en-US', { weekday: 'long' });
};
export const parsedPFDateTime = (date, format = DATE_FORMATS.DEFAULT) => {
  if (!date) return null;
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    return null;
  }
  return PFDate(parsedDate).format(format);
};
